/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-vertical-card': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18 19v1H2v-1h16zm1-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1v1l-.204-.01A2 2 0 0 1 .01 18.203L0 18V2A2 2 0 0 1 1.796.01L2 0h16l.204.01A2 2 0 0 1 20 2v16l-.01.204a2 2 0 0 1-1.786 1.785L18 20v-1a1 1 0 0 0 1-1z" _fill="#234357"/><path pid="1" d="M15.005 16V4M5.002 14V4" _stroke="#0076DD" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M10.004 12V4" _stroke="#234357" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
